import React, { useState, useEffect } from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import TextField from '@material-ui/core/TextField';
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";

function Filter() {
  const [dataForm, setDataForm] = React.useState({
    // useState hook
    dateFrom: new Date(),
    dateTo: new Date(),
  });

  const handleDateChange = (newValue) => {
    setDataForm({ ...dataForm, dateFrom: newValue, dateTo: newValue });
  };

  useEffect(() => {
    console.log(dataForm);
  }, [dataForm]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="Calendar">
        <Card elevation={1}>
          {/** <div>{JSON.stringify(dataForm)}</div> */}
          <CardContent>
            <div className="text-center">
              <h2>Reserve your spot</h2>
            </div>

            <Grid direction="row" container spacing={2} my={2.5}>
              <Grid item xs={12} sm={12} xl={3} lg={3}>
                <DateTimePicker
                  label="Date From"
                  value={dataForm.dateFrom}
                  onChange={(newValue) => {
                    setDataForm({ ...dataForm, dateFrom: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={12} xl={3} lg={3}>
                <DateTimePicker
                  label="Date To"
                  minDate={dataForm.dateFrom}
                  value={dataForm.dateTo}
                  onChange={(newValue) => {
                    setDataForm({ ...dataForm, dateTo: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={12} xl={3} lg={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleDateChange}
                >
                  Reserve
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={12} xl={12} lg={12} sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
              <h4>{dayjs(dataForm.dateFrom).format('DD/MM/YYYY')}</h4>
              <h4>{dayjs(dataForm.dateTo).format('DD/MM/YYYY')}</h4>
            </Grid> */}
            </Grid>
          </CardContent>
        </Card>
      </div>
    </LocalizationProvider>
  );
}

export default Filter;

//  {/* <div>Selected date: {selectedDate ? selectedDate.toString() : 'none'}</div>
//       <div>
//         {/* <div>{JSON.stringify(dataForm)} </div>// this is to see the dataForm object in the browser */}
//         <Card elevation={12}>
//         <CardContent >
//         <div><h3 className='text-center'>Rerseve your Spot </h3></div>
//         {/* <Grid container justifyContent="space-around"> */}
//           <Grid direction={'row'} container spacing={2} my={2.5} justifyContent="space-around">
//         <Grid item xs={12} sm={6} md={6} xl={9} lg={12}>
//         <DateTimePicker
//               label='Date/Time From'
//               value={dataForm.dateFrom}
//               onChange={(newValue) => {
//                 setDataForm({ ...dataForm, dateFrom: newValue })
//               }}
//               renderInput={(params) => <TextField {...params} fullWidth />}
//             />
//             </Grid>
//             <Grid item xs={12} sm={12} md={6} xl={9} lg={3}>
//             <DateTimePicker
//               label='Date/Time To'
//               value={dataForm.dateTo}
//               onChange={(newValue) => {
//                 setDataForm({ ...dataForm, dateTo: newValue })
//               }}
//               renderInput={(params) => <TextField {...params} fullWidth />}
//             />

//             {/* {dayjs(dataForm.dateFrom).format('MM/DD/YYYY', 'L LT')}

//             {dayjs(dataForm.dateTo).format('MM/DD/YYYY')} */}
//             </Grid>
//             </Grid>
//             </CardContent>
//             </Card>
//       </div>

// function Filter() {

//   //const [selectedDate, setSelectedDate] = React.useState(new Date());

//   const [dataForm, setDataForm] = React.useState<{ // useState hook
//     dateFrom: new Date(),
//     dateTo: new Date(),
//     selected: "date",
//   }>({
//     dateFrom: new Date(),
//     dateTo: new Date(),
//     selected: "date",
//   });

//   const { dateFrom, dateTo } = dataForm; // destructuring

//   const handleDateChange = (e) => {
//     setDataForm({
//       ...dataForm,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(dataForm);
//   };

// //   const handleDateChange = (date) => {
// //     setSelectedDate(date);
// //   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       {/* <div>Selected date: {selectedDate ? selectedDate.toString() : 'none'}</div> */}
//       <div>
//       <DateTimePicker

//             label="Date/Time From"
//             value={dataForm.dataForm}
//             onChange={new Date(): Date => new Date()}
//             renderInput={(props) => <TextField {...props} />}
//            />

//       <DateTimePicker

//             label="Date/Time To"
//             value={dataForm.dataForm}
//             onChange={(newValue: Date |
//onChange={handleDateChange}
//             renderInput={(props) => <TextField {...props} />}
//            />

//             {/* {selectedDate ? (

//                   <h3>Selected date: {selectedDate ? selectedDate.toString() : 'none'}</h3>
//             ) : (
//                <h3>Selected date: {selectedDate ? selectedDate.toString() : 'none'}</h3>

//             )}
//             {selectedDate.se} */}

//     </div>
//     </LocalizationProvider>
//   );
// }

// export default Filter;
